import React from 'react';

import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';
import { useServiceRequest } from '../../../components/ServiceStatusProvider';

const OrderHistorySection = ({ orders }) => {
  const navigate = useNavigate();
  const { requestCleaning } = useServiceRequest();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '';
    return `${date?.getFullYear()}.${String(date?.getMonth() + 1)?.padStart(2, '0')}.${String(date?.getDate())?.padStart(2, '0')}`;
  };

  const getStatusColor = (label) => {
    switch (label) {
      case '완료':
        return 'bg-success/10 text-success';
      case '배송 예정':
      case '세탁 진행중':
      case '세탁 중':
      case '픽업 예정':
        return 'bg-accent/10 text-accent';
      case '주문 접수':
        return 'bg-primary/10 text-primary';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const formatPrice = (price) => {
    return `${price?.toLocaleString('ko-KR')}원`;
  };

  if (!orders || orders?.length === 0) {
    return null;
  }

  return (
    <div className="w-full rounded-lg bg-card p-6 shadow-lg transition-all duration-300 hover:shadow-xl sm:p-8">
      <div className="mb-6 flex items-center justify-between">
        <h3 className="text-xl font-bold text-foreground">이전 주문 내역</h3>
        <span className="text-sm text-muted-foreground">{orders?.length}건</span>
      </div>
      <div className="space-y-4">
        {orders?.map((order) => (
          <div
            key={order?.orderNumber}
            className="rounded-lg border border-border p-4 transition-all duration-150 hover:border-primary/50 hover:shadow-md"
          >
            <div className="mb-3 flex items-start justify-between">
              <div className="flex-1">
                <p className="font-semibold text-foreground">주문번호: {order?.orderNumber}</p>
                <p className="mt-1 text-sm text-muted-foreground">{formatDate(order?.orderDate)}</p>
              </div>
              <div className={`rounded-full px-3 py-1 ${getStatusColor(order?.statusLabel)}`}>
                <p className="text-xs font-medium">{order?.statusLabel || '-'}</p>
              </div>
            </div>

            <div className="mb-3 space-y-2">
              {order?.items?.slice(0, 2)?.map((item, index) => (
                <div key={index} className="flex items-center justify-between text-sm">
                  <span className="text-muted-foreground">
                    {item?.brand} {item?.model}
                  </span>
                  <span className="font-medium text-foreground">{formatPrice(item?.price)}</span>
                </div>
              ))}
              {order?.items?.length > 2 && (
                <p className="text-xs text-muted-foreground">외 {order?.items?.length - 2}개 품목</p>
              )}
            </div>

            <div className="mb-4 flex items-center justify-between border-t border-border pt-3">
              <span className="text-sm font-medium text-muted-foreground">총 결제금액</span>
              <span className="text-lg font-bold text-primary">{formatPrice(order?.totalAmount)}</span>
            </div>

            <div className="flex gap-2">
              <Button
                variant="outline"
                size="sm"
                fullWidth
                iconName="RotateCcw"
                iconPosition="left"
                onClick={() => requestCleaning()}
              >
                재주문
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderHistorySection;